module.exports = __webpack_public_path__ + "static/img/deviceguanli.562ac47.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deviceguanli.gif
// module id = qi1m
// module chunks = 1